import { Modal } from 'components/layout/Modal'
import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import useTranslation from '../../../../../hooks/useTranslation'

interface ExtensionListFailModalProps {
  isOpenExtensionListFailModal: boolean
  setIsOpenExtensionListFailModal: Dispatch<SetStateAction<boolean>>
}

export const ExtensionListFailModal = ({
  isOpenExtensionListFailModal,
  setIsOpenExtensionListFailModal,
}: PropsWithChildren<ExtensionListFailModalProps>) => {
  const { t } = useTranslation()
  
  return (
    <Modal isModal={isOpenExtensionListFailModal}>
      <div className="bg-white w-[335px] h-auto p-[20px] border-t rounded-t-[20px]">
        <div className="flex flex-col items-center justify-center h-full gap-[24px]">
          <p className="font-bold text-[18px]">{t('productVideoEditor.extensionListFailModal.title')}</p>
          <div className="flex flex-col leading-[22px]">
            <p className="text-[14px]">
              {t('productVideoEditor.extensionListFailModal.description')}
            </p>
          </div>
        </div>
      </div>
      <div className="w-[335px] text-[14px]  h-[60px]  flex justify-center items-center">
        <button
          className="text-white w-[100%] h-full bg-main rounded-b-[20px] border-b border-main font-bold"
          onClick={() => {
            setIsOpenExtensionListFailModal((prev) => !prev)
          }}
        >
          <span>{t('common.confirm')}</span>
        </button>
      </div>
    </Modal>
  )
}
